import Phaser from 'phaser';
import { BaseScene } from '@core/scenes/BaseScene';
import {
  SceneKeys,
  Palette,
  GAME_TITLE,
} from '@core/config/constants';
import {
  CHARACTERS,
  GROUP_LINEUP_TEXTURE,
  GROUP_LINEUP_FILE,
} from '@core/config/characters';
import { MUSIC_TRACKS } from '@core/config/music';
import { BACKGROUNDS } from '@core/config/backgrounds';

const ASSETS_PATH = 'assets';

/**
 * Carga los recursos compartidos y muestra una barra de progreso. Cuando se agreguen
 * assets reales (sprites, audio) se cargan aca con this.load.* dentro de preload().
 */
export class PreloadScene extends BaseScene {
  public constructor() {
    super(SceneKeys.Preload);
  }

  public preload(): void {
    this.renderLoadingUi();

    this.load.image(GROUP_LINEUP_TEXTURE, `${ASSETS_PATH}/${GROUP_LINEUP_FILE}`);
    CHARACTERS.forEach((character) => {
      this.load.image(character.texture, `${ASSETS_PATH}/${character.file}`);
    });

    // Imagenes de los escenarios (incluye el escenario por defecto y los generados).
    BACKGROUNDS.forEach((option) => {
      if (option.background.type === 'image') {
        this.load.image(option.background.texture, `${ASSETS_PATH}/${option.background.file}`);
      }
    });

    // Pistas de musica opcionales: si el archivo no existe todavia, la escena usa la
    // musica generada por codigo. Ignoramos errores de carga para no romper el arranque.
    this.load.on(Phaser.Loader.Events.FILE_LOAD_ERROR, () => undefined);
    MUSIC_TRACKS.forEach((track) => {
      this.load.audio(track.key, `${ASSETS_PATH}/${track.file}`);
    });
  }

  public create(): void {
    const availableTracks = MUSIC_TRACKS.filter((track) => this.cache.audio.exists(track.key)).map(
      (track) => track.key,
    );
    this.audio.setAvailableTracks(availableTracks);
    this.scene.start(SceneKeys.Hub);
  }

  private renderLoadingUi(): void {
    const { width, height } = this.scale;

    this.add
      .text(width / 2, height / 2 - 60, GAME_TITLE, {
        fontFamily: 'Trebuchet MS, sans-serif',
        fontSize: '48px',
        color: '#ffffff',
      })
      .setOrigin(0.5);

    const barWidth = 420;
    const barHeight = 28;
    const barX = (width - barWidth) / 2;
    const barY = height / 2 + 20;

    const border = this.add.graphics();
    border.lineStyle(3, Palette.accent, 1);
    border.strokeRoundedRect(barX, barY, barWidth, barHeight, 14);

    const fill = this.add.graphics();
    this.load.on('progress', (value: number) => {
      fill.clear();
      fill.fillStyle(Palette.primary, 1);
      fill.fillRoundedRect(barX + 4, barY + 4, (barWidth - 8) * value, barHeight - 8, 10);
    });
  }
}
